import React from 'react';
import { CompetencyStatus, STATUS_CELL_LABELS, statusSlug } from './config';

/** Competency status → coloured pill for matrix cells. */
export const competencyBadge = (status: CompetencyStatus): React.ReactElement => (
  <span className={`competency-badge competency-badge--${statusSlug(status)}`}>
    {STATUS_CELL_LABELS[status]}
  </span>
);
